import axios from './axios';

const countExercises = (exerciseCount, source) => {
    axios.request({
        method: 'POST',
        url: '/api/counter',
        data: {
            exerciseCount,
            source,
        },
    });
};

export default countExercises;
